import groupByApptStatus from 'utils/group-by-appt-status.js';

angular
.module('inkfinder')
.factory('DashboardData', function DashboardData(
  $q,
  $http,
  $rootScope,
  $interval,
  ENDPOINT,
  Session,
  moment,
  Appointments,
  Shop,
  ScheduleUtilFactory,
  MergeProjects,
  _
) {
  // Public variables
  DashboardData.data = [];
  DashboardData.merged = [];
  DashboardData.activeAppointmentsCount = 0;

  // Public methods
  DashboardData.get = get;
  DashboardData.refresh = refresh;
  DashboardData.reset = reset;

  // Private variables
  let timer;
  let refreshing = false;
  let timestamp;
  let refreshInterval;

  /**
   * @name refresh
   * @description Function to determine if we should get new data from the API.
   * @param {date} startOfDay Moment object for the start of the shop day.
   * @param {date} endOfDay Moment object for the end of the shop day.
   * @return {promise} Promise Returns a promise so the resolve on the state
   * loads.
   */
  function refresh(startOfDay, endOfDay) {
    return $q(function(resolve, reject) {
      if (shouldRefresh()) {
        resolve(get(startOfDay, endOfDay));
      } else {
        resolve('Load cache');
      }
    });
  }

  /**
   * @name createAppointmentTimer
   * @description Function to create an internal timer and call.
   * @param {date} startOfDay Moment object for the start of the shop day.
   * @param {date} endOfDay Moment object for the end of the shop day.
   * refreshAppointments() at a specific interval.
   */
  function createAppointmentTimer(startOfDay, endOfDay) {
    timer = $interval(function() {
      refresh(startOfDay, endOfDay);
    }, 1000);
  }

  /**
   * @name shouldRefresh
   * @description Unknown
   * @return {boolean} Returns true/false depending on refreshing and updated
   */
  function shouldRefresh() {
    let result;
    let isNotRefreshing = !refreshing;
    let now = moment();
    let isTime = (!refreshInterval ||
    now.diff(refreshInterval, 'seconds') >= 7);
    result = isNotRefreshing && isTime;
    return result;
  }

  /**
   * @name get
   * @description Function to get appointments.
   * @param {date} startOfDay Moment object for the start of the shop day.
   * @param {date} endOfDay Moment object for the end of the shop day.
   * @return {empty} Empty Returns without sending data.
   */
  function get(startOfDay, endOfDay) {
    refreshing = true;
    let search = false;
    let _timestamp = null;
    if (timestamp) {
      _timestamp = timestamp.format('X');
    }
    return Appointments.get(search, startOfDay, endOfDay, _timestamp)
    .then(function(appointments) {
      refreshing = false;
      refreshInterval = moment();
      if (appointments.length > 0) {
        return MergeProjects.merge(appointments).then(function(mergedData) {
          DashboardData.merged =
          _.unionBy(mergedData, DashboardData.merged,
          function(data) {
            return data.appointment.id;
          });
          DashboardData.data =
          groupByApptStatus(DashboardData.merged);
          if (DashboardData.data.confirmed) {
            DashboardData.activeAppointmentsCount =
            DashboardData.data.confirmed.length;
          }
          if (DashboardData.data.completed) {
            DashboardData.activeAppointmentsCount +=
            DashboardData.data.completed.length;
          }
          timestamp = moment();
          if (!timer) {
            createAppointmentTimer(startOfDay, endOfDay);
          }
        });
      }
    });
  }

  let deregister = $rootScope.$on('clear-data', reset);
  $rootScope.$on('$destroy', deregister);

  /**
   * @name reset
   * @description Reset variables
   */
  function reset() {
    DashboardData.data = [];
    DashboardData.merged = [];
    DashboardData.activeAppointmentsCount = 0;
    $interval.cancel(timer);
    refreshing = false;
    refreshInterval = null;
    timestamp = null;
  }
  return DashboardData;
});



// WEBPACK FOOTER //
// ./components/dashboard/dashboard.data.js